import { Navigate, useSearchParams } from 'react-router-dom'

export function parseProjectIdQuery(searchParams: URLSearchParams): number | null {
  const raw = searchParams.get('projectId')
  if (!raw) return null
  const id = parseInt(raw, 10)
  return Number.isFinite(id) && id > 0 ? id : null
}

/** Database create/connect/synthetic guides require a project; org-level entry redirects. */
export default function RequireProjectQuery({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams()
  if (parseProjectIdQuery(searchParams) == null) {
    return <Navigate to="/projects" replace />
  }
  return <>{children}</>
}
